import React, {createContext, useContext} from 'react';
import {useDispatch} from 'react-redux';
import {FormikProvider, useFormik} from 'formik';
import {useTransfersByAgentContext} from './TransfersByAgentContext';
import * as actions from '../_redux/transfersByAgentActions';

const BulkActionsContext = createContext({});

export const useBulkActionsContext = () => useContext(BulkActionsContext);

export const BulkActionsProvider = ({children}) => {
  const dispatch = useDispatch();
  const findAgents = (text) => {
    return actions.findAgents(text);
  };
  const {
    dataUnpaidReceiptLines,
    dataHiddenReceiptLines,
    getTransfersByAgent,
    agentId
  } = useTransfersByAgentContext();
  const unitedLines = [...dataUnpaidReceiptLines, ...dataHiddenReceiptLines];
  const initialValues = unitedLines.reduce((acc, item) => {
    return {...acc, [item._id]: false}
  }, {});

  const formik = useFormik({
    initialValues: {...initialValues},
    onSubmit: () => {
    },
    enableReinitialize: true
  });

  const getSelectedLines = () => {
    let result = [];
    for (let key in formik.values) {
      if (formik.values[key] === true) {
        result.push(key)
      }
    }
    return result
  };
  const hasSelectedLines = getSelectedLines().length > 0;
  const update = () => {
    getTransfersByAgent();
    formik.resetForm();
  };
  const handleSetHidden = () => {
    dispatch(actions.setReceiptLineHidden(getSelectedLines(), true, agentId));
    update();
  };
  const handleSetShowed = () => {
    dispatch(actions.setReceiptLineHidden(getSelectedLines(), false, agentId));
    update();
  };
  const handleSetOwnership = (agentID) => {
    dispatch(actions.setReceiptLineOwnership(getSelectedLines(), agentID));
    update();
  };
  const handleRestoreOwnership = () => {
    dispatch(actions.resetReceiptLineOwnership(getSelectedLines(), agentId));
    update();
  };

  return (
    <BulkActionsContext.Provider
      value={{
        formik,
        hasSelectedLines,
        handleSetHidden,
        handleSetShowed,
        handleSetOwnership,
        handleRestoreOwnership,
        findAgents
      }}
    >
      <FormikProvider value={formik}>
        {children}
      </FormikProvider>
    </BulkActionsContext.Provider>
  );
};